"use client"

import { redirect } from "next/navigation"
import { Navbar } from "@/app/components/navbar"
import { Footer } from "@/app/components/footer"
import { DesignerWizard } from "@/app/wizards/designer/DesignerWizard"
import { useSession } from "@/app/context/AuthContext"

export default function DesignerPage() {
  const { status } = useSession()

  // Redirect unauthenticated users to demo
  if (status === "unauthenticated") {
    redirect("/designer/demo")
  }

  // Show loading state during auth check
  if (status === "loading") {
    return (
      <main className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#40A1AB]"></div>
        </div>
        <Footer />
      </main>
    )
  }

  return (
    <main className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-1">
        <DesignerWizard />
      </div>
      <Footer />
    </main>
  )
}
